import { render, staticRenderFns } from "./NavbarButton.vue?vue&type=template&id=24867712"
import script from "./NavbarButton.vue?vue&type=script&lang=js"
export * from "./NavbarButton.vue?vue&type=script&lang=js"
import style0 from "./NavbarButton.vue?vue&type=style&index=0&id=24867712&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports